import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const accessToken = useSelector((state) => state.auth.accessToken);
  const userType = useSelector((state) => state.auth.userInfo?.role?.toLowerCase());
  const location = useLocation();
  if (location.pathname === "/" || location.pathname === "/auth/login") {
    if (accessToken) {
      if (userType === "professional" || userType === "professional agreement controller head") {
        return <Navigate to="/admin/company/professional" replace />;
      } else {
        return <Navigate to="/admin/dashboard" replace />;

      }
    } else {
      if (location.pathname !== "/auth/login") {
        return <Navigate to="/auth/login" replace />;
      }
    }
  }
  return children;
};

export default AuthGuard;
